const SET_LIST = (state, obj) => {
  state.list = obj
}

const SET_LIST_AVAILABLE = (state, obj) => {
  state.listAvaliable = obj
}

const SET_INFORMATION = (state, obj) => {
  state.informationCampaign = {
    ...obj,
    operation: obj.infos.operations.reduce((defaultObj, opt) => {
      if (obj.fund_id === opt.fund_id) {
        defaultObj = opt
      }
      return defaultObj
    }, {}),
    errors: Object.values(obj.infos.errors).reduce((errors, error) => {
      errors = errors.concat(error)
      return errors
    }, [])
  }
}

const RESET_INFORMATION = (state) => {
  state.informationCampaign = JSON.parse(JSON.stringify(state.initInformationCampaign))
}

export default {
  SET_LIST,
  SET_LIST_AVAILABLE,
  SET_INFORMATION,
  RESET_INFORMATION
}



// WEBPACK FOOTER //
// ./src/features/campaigns/store/mutations.js